import { render, staticRenderFns } from "./index.vue?vue&type=template&id=4ad8376e&scoped=true&lang=pug"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=4ad8376e&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ad8376e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/workspaces/wuwow-junior-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4ad8376e')) {
      api.createRecord('4ad8376e', component.options)
    } else {
      api.reload('4ad8376e', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=4ad8376e&scoped=true&lang=pug", function () {
      api.rerender('4ad8376e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/home/parent/registerModal/index.vue"
export default component.exports